import React from 'react';
import { Formik, Form as FormikForm } from 'formik';

const Form = FormikForm as unknown as React.ComponentType<
  React.PropsWithChildren<Record<string, unknown>>
>;

import { getTranslation } from 'helpers/getTranslation';

import { Drawer } from 'components/shared/Drawer';
import { Button } from 'components/shared/Button';
import { Loading } from 'components/shared/Loading';

import { FormikField } from 'components/FormikField';
import { UploadField } from 'components/FormikFields';
import { InputField } from 'components/FormikFields';

import { validationSchema } from './MarketingSettings.formConfig';

import styles from './MarketingSettings.module.scss';

const MarketingSettings = ({
  open,
  saveLoading,
  course,
  onClose,
  onSaveClick,
}: {
  open: any;
  saveLoading: any;
  course: any;
  onClose: any;
  onSaveClick: any;
}) => (
  <Drawer
    open={open}
    headerContent={getTranslation('course_page.marketing_settings.header')}
    onClose={onClose}
  >
    <Formik
      enableReinitialize
      initialValues={{
        socialPreview: course?.socialPreview,
        order: (course && course.order) || 0,
        freeLessonsCount: (course && course.freeLessonsCount) || 0,
      }}
      validateOnMount
      validationSchema={validationSchema}
      onSubmit={onSaveClick}
    >
      <Form className={styles.form}>
        <div className={styles.inner}>
          <FormikField
            name="socialPreview"
            component={UploadField}
            controlProps={{
              label: getTranslation(
                'course_page.marketing_settings.preview_label',
              ),
            }}
            componentProps={{
              type: 'input',
              variant: 'imageBlock',
              className: styles.uploadField,
              accept: {
                'image/jpeg': ['.jpg', '.jpeg'],
                'image/png': ['.png'],
              },
            }}
          />
          <FormikField
            name="order"
            component={InputField}
            controlProps={{
              label: getTranslation(
                'course_page.marketing_settings.order_label',
              ),
            }}
            componentProps={{
              value: (course && course.order) || 0,
            }}
          />

          <FormikField
            name="freeLessonsCount"
            component={InputField}
            controlProps={{
              label: 'Free lessons count',
            }}
          />
        </div>

        <div className={styles.actions}>
          <Button
            className={styles.action}
            size="md"
            variant="outlined"
            onClick={onClose}
          >
            {getTranslation('common.button.cancel')}
          </Button>
          <Button
            className={styles.action}
            startIcon={
              saveLoading && <Loading color={'var(--color-white-primary)'} />
            }
            type="submit"
            size="md"
          >
            {getTranslation('common.button.save')}
          </Button>
        </div>
      </Form>
    </Formik>
  </Drawer>
);

export default React.memo(MarketingSettings) as any;
